import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { WButton } from '@wareclouds/wareclouds-ui';
import { Trans, useTranslation } from 'react-i18next';
import {
  closePushNotificationDialogs,
  setPermission,
} from '../../pushNotificationsSlice';
import { useDispatch } from 'react-redux';
import env from '../../../../config/env';

export default function PushNotificationsPermissionDialog({ open }) {
  const dispatch = useDispatch();
  const { t } = useTranslation(['button', 'description', 'title']);

  const isDenied = Notification.permission === 'denied';

  const closeModal = () =>
    dispatch(closePushNotificationDialogs('showPushPermissionModal'));

  const handleRequestPermission = async () => {
    const permission = await Notification.requestPermission();
    dispatch(setPermission(permission));
    closeModal();
  };

  return (
    <Dialog open={open}>
      <DialogTitle>
        {t('notifications.push.active', { ns: 'title' })}
      </DialogTitle>
      <DialogContent>
        {isDenied ? (
          <Trans
            t={t}
            i18nKey={
              env.PUSH_NOTIFICATION_HELPER_LINK
                ? 'notifications.push.denied_link'
                : 'notifications.push.denied_generic'
            }
            ns="description"
            components={{
              strong: env.PUSH_NOTIFICATION_HELPER_LINK ? (
                <Box
                  component="a"
                  href={env.PUSH_NOTIFICATION_HELPER_LINK}
                  target="_blank"
                  color="primary"
                  sx={{ fontWeight: 600, textDecoration: 'underline' }}
                />
              ) : (
                <Box component="span" sx={{ fontWeight: 600 }} />
              ),
            }}
          />
        ) : (
          <>{t('notifications.push.active', { ns: 'description' })}</>
        )}
      </DialogContent>
      <DialogActions>
        <WButton
          label={t('later', { ns: 'button' })}
          onClick={closeModal}
          color="error"
        />
        {!isDenied && (
          <WButton
            label={t('accept', { ns: 'button' })}
            onClick={handleRequestPermission}
            color="primary"
          />
        )}
      </DialogActions>
    </Dialog>
  );
}
